import { start } from '@anycable/turbo-stream';
import cable from 'common/lib/AnyCable/cable';

export function startAnyCableTurboStream() {
  start(cable, {
    requestSocketIDHeader: true,
    tagName: 'turbo-cable-stream-source',
  });
}
